import React from "react";
import Avatar from "../../common/components/Avatar";
import Paragraph from "../../common/ui/Paragraph";
import Icons from "../../common/components/Icons";
import avatar from "../../../assets/images/webp/testimonials-avatar-1.webp";

const SliderCard = () => {
  return (
    <div className="flex flex-col items-center justify-center max-md:max-w-[309px] max-md:mx-auto">
      <Avatar
        src={avatar}
        alt="testimonial"
        size={100}
        responsiveSize={{ 768: 80 }}
        className=""
      />
      <h2 className="pt-4 pb-1 font-bold !leading-100 text-xl text-custom-black font-lato">
        John Mitchell
      </h2>
      <Paragraph
        variant="opacity"
        className="max-w-[485px] mx-auto !leading-155 font-lato">
        CEO of TechVision Inc.
      </Paragraph>
      <Paragraph
        variant="opacity"
        className="mt-5 max-w-[485px] mx-auto !leading-155 font-lato relative">
        <Icons
          className="absolute left-0 top-0 -translate-x-full -translate-y-1/4 max-md:w-7 max-md:left-6 max-md:-top-2"
          icon="golden-commas"
        />
        <Icons
          className="absolute right-0 bottom-0 translate-x-full rotate-180 translate-y-1/4 max-md:w-7 max-md:right-20"
          icon="golden-commas"
        />
        This team exceeded our expectations! Their innovative approach and
        seamless collaboration helped us turn our vision into reality. The
        tailored strategies provided a competitive edge, and their transparency
        made the entire process smooth. Highly recommended!
      </Paragraph>
    </div>
  );
};

export default SliderCard;
